export default __webpack_public_path__ + "static/media/work2.8cb84a57.svg";